export default __webpack_public_path__ + "0c898e3b865329fb2aa576824ba067b2.webp";